import { Component, h } from "preact";

export function Icon({ children, width = 16, height = 16, color }) {
  const viewBox = "0 0 50 50";

  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g stroke={color} fill={color}>
        {children}
      </g>
    </svg>
  );
}
